import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';

const ListPage = lazy(() => import('@/features/contracts/list/page'));
const CreatePage = lazy(() => import('@/features/contracts/create/page'));
const InfoPage = lazy(() => import('@/features/contracts/info/page'));
const TemplatesPage = lazy(() => import('@/features/contracts/templates/list/page'));

// WorkerContracts.md uses `/contract/worker/*` URLs. Relay keeps
// `/contracts/*` as canonical and redirects the spec paths so old
// Haken bookmarks + cross-module links resolve.
export const contractsRoutes: RouteObject[] = [
  { path: 'contracts', element: <ListPage /> },
  { path: 'contracts/new', element: <CreatePage /> },
  { path: 'contracts/templates', element: <TemplatesPage /> },
  { path: 'contracts/:id', element: <InfoPage /> },
  { path: 'contract/worker', element: <Navigate to="/contracts?contract_kind=worker" replace /> },
  { path: 'contract/worker/new', element: <Navigate to="/contracts/new?contract_kind=worker" replace /> },
  { path: 'contract/worker/list', element: <Navigate to="/contracts?contract_kind=worker" replace /> },
  { path: 'contract/worker/templates', element: <Navigate to="/contracts/templates?kind=contract_worker" replace /> },
  { path: 'contract/worker/form', element: <Navigate to="/contracts/new?contract_kind=worker" replace /> },
  { path: 'contract/worker/info', element: <Navigate to="/contracts?contract_kind=worker" replace /> },
  // CompanyContracts.md §0 dropdown paths.
  { path: 'contract/company', element: <Navigate to="/contracts?contract_kind=company" replace /> },
  { path: 'contract/company/new', element: <Navigate to="/contracts/new?contract_kind=company" replace /> },
  { path: 'contract/company/list', element: <Navigate to="/contracts?contract_kind=company" replace /> },
  { path: 'contract/company/templates', element: <Navigate to="/contracts/templates?kind=contract_company" replace /> },
  { path: 'contract/company/form', element: <Navigate to="/contracts/new?contract_kind=company" replace /> },
  { path: 'contract/company/info', element: <Navigate to="/contracts?contract_kind=company" replace /> },
];
